import { useRouter } from '@speedlo/hooks'
import { useObserver } from 'mobx-react-lite'
import React, { useCallback } from 'react'
import { SegmentKey } from 'shopify-payment-core'

import { LoaderSpinner } from '../atoms/LoaderSpinner'
import { useRoot } from '../atoms/RootProvider'
import { SwitchBarAdmin } from '../molecules/SwitchBarAdmin'
import { SwitchBarClient } from '../molecules/SwitchBarClient'

export const SwitchBar: React.FC = () => {
  const { auth } = useRoot()
  const { match, history } = useRouter<{ accountId: ID }>({
    path: '/admin/:accountId',
  })

  const onNavigate = useCallback(
    (id: ID) => {
      history.push(`/admin/${id}`)
    },
    [history],
  )

  const props = {
    onNavigate,
    selected: match ? match.params.accountId : null,
    segmentKey: 'gopay' as SegmentKey,
  }

  return useObserver(() => {
    if (!auth.isAuthenticated) {
      return <LoaderSpinner />
    }
    return auth.isAdmin ? (
      <SwitchBarAdmin {...props} />
    ) : (
      <SwitchBarClient {...props} />
    )
  })
}
